<template>
  <div>
    <v-card>
      <v-card-title>
        Compras
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <Listado
          :datos="datos"
          :encabezados="encabezados"
          :acciones="acciones"
        ></Listado>
      </v-card-text> 
    </v-card>
  </div>
</template>
<script>
import Listado from "@/components/Listado.vue";
export default {
  name: "Compras_Listado",
  components: {
    Listado,
  },
  data() {
    return {
      datos: "/compras",
      encabezados: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta",
        },
        {
          text: 'Tipo', value: "tipo"
        },
        { text: "Proveedor", value: "proveedor.nombre" },
        { text: "Tipo de Comprobante", value: "comprobanteCompra.tipo" },
        { text: "Numero de Comprobante", value: "comprobanteCompra.numero" },
        { text: "Total", value: "totalCompra" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      acciones: {
        ver: "/compras/",
      }
    };
  },
  methods: {
    _nuevo() {
      this.$router.push(`/compras/nuevo`);
    },
  },
};
</script>
